import { render, staticRenderFns } from "./sales-summary.vue?vue&type=template&id=689c30e8&scoped=true&"
import script from "./sales-summary.vue?vue&type=script&lang=ts&"
export * from "./sales-summary.vue?vue&type=script&lang=ts&"
import style0 from "./sales-summary.vue?vue&type=style&index=0&id=689c30e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c30e8",
  null
  
)

export default component.exports